module.exports = __webpack_public_path__ + "img/sidebar-company-profile-ico-wht.73cf7a24.svg";